import { JsonObject } from '@mainstage/types';
import { z } from 'zod';

const JsonObjectSchema = z.custom<JsonObject>(value => {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}, 'Expected a JSON object');

export const SchemaValidatorCompilerInputSchema = z.object({
  specParameters: z.array(JsonObjectSchema),
});

/**
 * Input for schema validator compilation
 */
export type SchemaValidatorCompilerInput = z.infer<
  typeof SchemaValidatorCompilerInputSchema
>;

/**
 * A compiled validator
 */
export interface ValidatorInner {
  /** JavaScript code generated by AJV using compileSchemaValidatorsCode */
  code: string;
}

/**
 * Result of schema validator compilation
 */
export interface ValidatorResult {
  /** Array of compiled validators */
  validators: ValidatorInner[];
}
